import { createFileRoute } from "@tanstack/react-router";
import { AccountDashboardPage } from "@/features/dashboards/pages";

export const Route = createFileRoute("/_app/dashboards/account/$accountId")({
  head: () => ({ meta: [{ title: "Account dashboard · Malfak" }] }),
  component: AccountDashboardRoute,
});

function AccountDashboardRoute() {
  const { accountId } = Route.useParams();
  return <AccountDashboardPage accountId={accountId} key={accountId} />;
}
